/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Detail-page summary cards (035 US6) for ONE pinned user's filtered standing-check
 * records, on the shared au-card system: Total Records, Tests Aborted (count + % of
 * Total Records), In Doctor Report (count), avg Peak HR and avg Baseline HR. Derived
 * from the same filtered set so they reconcile with the table. The aborted % shows
 * "—" on an empty set (no divide-by-zero); the HR averages show "—" when the API
 * returns null (the TEXT-column cast guard yields null when no numeric samples exist).
 *
 * Props: { totalRecords, abortedCount, inDoctorReportCount, avgPeakHr, avgBaselineHr }
 * (avgPeakHr / avgBaselineHr may be null → rendered as "—")
 */
const n = (v) => Number(v || 0).toLocaleString();

const bpm = (v) => (v == null ? '—' : `${Math.round(Number(v))} bpm`);

const abortedPct = (aborted, total) => {
  if (!total || total <= 0) return '—';
  const p = (Number(aborted) / total) * 100;
  return p < 1 && p > 0 ? '<1%' : `${Math.round(p)}%`;
};

const StandingCheckDetailSummaryCards = ({
  totalRecords = 0,
  abortedCount = 0,
  inDoctorReportCount = 0,
  avgPeakHr = null,
  avgBaselineHr = null,
}) => (
  <div className="au-cards" data-testid="sc-detail-summary">
    <div className="au-card">
      <span className="au-card__label">Total Records</span>
      <span className="au-card__value tnum">{n(totalRecords)}</span>
    </div>
    <div className="au-card">
      <span className="au-card__label">Tests Aborted</span>
      <span className="au-card__value tnum">{n(abortedCount)}</span>
      <span className="au-card__sub" data-testid="sc-aborted-pct">{abortedPct(abortedCount, totalRecords)} of records</span>
    </div>
    <div className="au-card">
      <span className="au-card__label">In Doctor Report</span>
      <span className="au-card__value tnum">{n(inDoctorReportCount)}</span>
    </div>
    <div className="au-card">
      <span className="au-card__label">Avg Peak HR</span>
      <span className="au-card__value tnum" data-testid="sc-avg-peak">{bpm(avgPeakHr)}</span>
    </div>
    <div className="au-card">
      <span className="au-card__label">Avg Baseline HR</span>
      <span className="au-card__value tnum" data-testid="sc-avg-baseline">{bpm(avgBaselineHr)}</span>
    </div>
  </div>
);

export default StandingCheckDetailSummaryCards;
